<jqxWindow #form [theme]="theme" [width]="1200" [height]="500" [zIndex]="50" [position]="getFormPos(form)"
    [autoOpen]="true" [zIndex]="90" [showCloseButton]="true" [showCollapseButton]="true" [resizable]="false"
    (onClose)="onClose()">
    <div class="formHeader" style="overflow-x: hidden;">
        {{translate('Historico_envios_dispositivo_identificador')}}
    </div>
    <div class="form" style="float:left; overflow: hidden;">
        <div class="group-botom" style="display: flex;">
            <div style="display: flex;align-items: center;gap: 2px;">
                <span style="margin-left: 4px;">{{translate('Periodo')}}</span>
                <app-periodo-select #periodoSelect [noTrimestre]="true" [noSemestre]="true" [noLibre]="true"
                    [height]="24">
                </app-periodo-select>
            </div>
            <div style="display: flex;align-items: center;">
                <div style="display: flex; align-items: flex-end;">
                    <jqxCheckBox #checkTodas (onChange)="changeTodos($event)" [theme]="theme" [width]="20" [height]="20"
                        [checked]="true">
                    </jqxCheckBox> <span style="margin-left: 4px;">{{translate('Mostrar_todas_lecturas')}}</span>
                </div>
                <div style="display: flex;align-items: center;margin-left: 5px; gap: 2px;">
                    <jqxCheckBox #checkMasXmetros (onChange)="changeMasXmetros($event)" [theme]="theme"
                        style="margin-left: 10px; float: left;" [width]="20" [height]="20">
                    </jqxCheckBox> <span style="margin-left: 4px;">{{translate('Lecturas')}}</span>
                    <jqxNumberInput #currencyInput [theme]="theme" [width]="50" [height]="25" [spinButtons]="true"
                        [inputMode]="'simple'" [decimalDigits]="0" (onValueChanged)="valueChangedNumber($event)"> </jqxNumberInput>
                    <span style="margin-left: 4px;">{{translate('Metros')}}</span>
                </div>
            </div>

            <jqxButton style="float:left; margin-left: 18px;" [width]='100' [height]='22'
                [textImageRelation]='"imageBeforeText"' [textPosition]='"center"' [imgSrc]='"/assets/images/save.png"'
                [value]="translate('ACEPTAR')" (onClick)="onAceptar($event)">
            </jqxButton>
            <jqxButton style="float:left; margin-left: 4px;" [width]='100' [height]='22'
                [textImageRelation]='"imageBeforeText"' [textPosition]='"center"'
                [imgSrc]='"/assets/images/exportar.png"' [value]="translate('Exportar')" (onClick)="onExportar($event)">
            </jqxButton>
        </div>
        <jqxGrid #grid [theme]="theme" [width]="'100%'" [height]="440" [source]="dataAdapter" [columnsresize]="true"
            [sortable]="true" [showrowlines]="false" [showcolumnlines]="true" [columns]="columns" [altrows]="true"
            [enabletooltips]="true" [filterable]="true" [showstatusbar]="true" [statusbarheight]="20"
            [rowdetails]="true" [showaggregates]="true" [rowsheight]="20" [columnsheight]="20" [localization]="langGrid"
            [groupable]="true" [rowdetailstemplate]="rowdetailstemplate" [initrowdetails]="initrowdetails"
            (onRowdoubleclick)="onRowdoubleclick($event)">
        </jqxGrid>
    </div>
</jqxWindow>